import { Injector } from '@angular/core';
import { OrderWorkflowFacade } from '@features/client/order-workflow/facades/order-workflow.facade';

export const urlPlaceholders = [
  {
    key: 'orderId',
    callback: (injector: Injector) => {
      const orderWorkflowFacade = injector.get(OrderWorkflowFacade);

      return orderWorkflowFacade.getOrderSnapshot().id;
    },
  },
];
